  $(document).ready(function () {
 
    const url = window.location.pathname;
    const url_result = url.split("/collections/").pop();

    // Remove any previously set active classes before checking conditions
    $(".tabs-ul li").removeClass("active-tab");

    $(".tabs-ul li").each(function () {
      const data_attr = $(this).attr("data-handle");

      if (url_result == data_attr) {
        $(this).addClass("active-tab");
        return false;
      } 
    });

    // Click event to switch tabs
    $(".tabs-ul li").click(function () {
      $(".tabs-ul li").removeClass("active-tab"); // Remove active class from all
      $(this).addClass("active-tab"); // Add active class to clicked tab
    });
  });

  window.onpageshow = function(event) {
    if (event.persisted) {
      window.location.reload();
    }
  };